module.exports = __webpack_public_path__ + "img/report-page1.27b59315.svg";